import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from '@haldor/ui';
var GroupFilter = /*#__PURE__*/function (_Component) {
  function GroupFilter(props) {
    var _this;
    _classCallCheck(this, GroupFilter);
    _this = _callSuper(this, GroupFilter, [props]);
    _defineProperty(_this, "componentDidMount", function () {
      //this.dataLoad(this.props.userId);
    });
    _defineProperty(_this, "dataLoad", function (studentId) {});
    _defineProperty(_this, "reset", function () {
      _this.setState({
        value: '0'
      }, function () {
        if (_this.props.onChange) {
          _this.props.onChange('0');
        }
      });
    });
    _defineProperty(_this, "onChange", function (event) {
      if (_this.props.onChange) {
        _this.props.onChange(event.target.value);
      }
      _this.setState({
        value: event.target.value
      });
    });
    _this.state = {
      value: '0'
    };
    return _this;
  }
  _inherits(GroupFilter, _Component);
  return _createClass(GroupFilter, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      var differentUserId = this.props.userId !== nextProps.userId;
      var differentProps = this.props !== nextProps;
      var differentState = this.state !== nextState;
      if (differentUserId) {
        this.dataLoad(nextProps.userId);
      }
      if (differentProps || differentState) {
        return true;
      }
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        groups = _this$props.groups,
        translate = _this$props.translate;
      return /*#__PURE__*/React.createElement("div", {
        className: "form"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row",
        style: {
          padding: 0
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "select"
      }, /*#__PURE__*/React.createElement("label", {
        style: {
          marginTop: 0
        }
      }, translate('Group')), /*#__PURE__*/React.createElement("select", {
        value: this.state.value,
        onChange: this.onChange
      }, /*#__PURE__*/React.createElement("option", {
        value: "0"
      }, translate('Select an alternative')), groups != null ? groups.map(function (group) {
        return /*#__PURE__*/React.createElement("option", {
          key: "gfilter-section-".concat(group.id),
          value: group.id
        }, group.title);
      }) : null), this.state.value != '0' ? /*#__PURE__*/React.createElement("div", {
        style: {
          paddingTop: '0.25em',
          cursor: 'pointer'
        },
        onClick: this.reset
      }, translate('Reset filter')) : null)));
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    groups: state.groups.progressSections,
    translate: translate(state.Languages.translations)
  };
}
export default connect(mapStateToProps, {})(GroupFilter);